import MenuItem, { LinkContainer } from "@components/MenuItem"
import { getIn } from "@utils/index"
import { FilterFunnelProps } from "@utils/types"
import {
  getShopURLForBrandDeviceType,
  getShopURLForDevice,
  getShopURLForDeviceType,
} from "@utils/urls"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  ${LinkContainer} {
    padding: 18px 10px 18px 20px;
  }
`

interface DeviceTypeFilterProps {
  data: Array<{
    menuLabel: string
    slug: string
  }>
  filterFunnel: FilterFunnelProps
}

const DeviceTypeFilter: React.FC<DeviceTypeFilterProps> = ({
  data,
  filterFunnel,
}) => {
  const getShopURL = (slug) => {
    const thisFilterFunnel: any = getIn(filterFunnel, `deviceType.${slug}`, {})
    const brands = Object.keys(thisFilterFunnel)
    const brand = brands.length > 0 && thisFilterFunnel[brands[0]]

    if (brand && brand.devices.length === 1) {
      return getShopURLForDevice(brand.devices[0].slug)
    } else if (brand) {
      return getShopURLForBrandDeviceType(brand.brandSlug, slug)
    } else {
      return getShopURLForDeviceType(slug)
    }
  }

  const formatDeviceType = ({ menuLabel, slug }) => ({
    label: menuLabel,
    link: getShopURL(slug),
  })

  const menuItems = React.useMemo(
    () => data.map(formatDeviceType),
    [filterFunnel, data]
  )

  return (
    <Container>
      {menuItems.map(({ label, link }) => (
        <MenuItem key={link} label={label} link={link} />
      ))}
    </Container>
  )
}

export default DeviceTypeFilter
